import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { style: {"text-align":"center"} }
const _hoisted_8 = ["disabled"]

import { InterestedParty } from "@/models/InterestedParty";
import UsStatesBox from "@/components/UsStatesBox.vue";
import { ref, computed, onUnmounted } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import useModal from "@/hooks/useModal";

export default /*@__PURE__*/_defineComponent({
  __name: 'AddInterestedPartyModal',
  props: {
  name: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;
const { toggleModal, onModalMounted, onModalDestroy } = useModal();
const modalClass = onModalMounted(props.name);
onUnmounted(() => {
  onModalDestroy(props.name);
});
const interestedParty = ref(new InterestedParty());
const quoteStore = useQuoteStore();
const quote = quoteStore;

const addInterestedParty = () => {
  // Emit the newly added user
  quote.checkout.interestedParty = interestedParty.value;
  toggleModal(props.name);
  interestedParty.value = new InterestedParty();
};

const validated = computed(() => {
  return (
    interestedParty.value.firstName &&
    interestedParty.value.address.address &&
    interestedParty.value.address.city &&
    interestedParty.value.address.zip &&
    interestedParty.value.address.state &&
    interestedParty.value.address.state.short
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(modalClass))
  }, [
    _createElementVNode("div", {
      class: "content",
      onModalClose: _cache[8] || (_cache[8] = ($event: any) => (_unref(toggleModal)(__props.name)))
    }, [
      _createElementVNode("span", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleModal)(__props.name)))
      }, "X"),
      _cache[15] || (_cache[15] = _createElementVNode("h4", { style: {"text-align":"center"} }, "Add Interested Party", -1)),
      _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "tinylabel" }, [
          _createTextVNode("Name "),
          _createElementVNode("red", null, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((interestedParty.value.firstName) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, interestedParty.value.firstName]
        ])
      ]),
      _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "tinylabel" }, [
          _createTextVNode("Street Address "),
          _createElementVNode("red", null, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((interestedParty.value.address.address) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, interestedParty.value.address.address]
        ])
      ]),
      _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "tinylabel" }, "Apt / Suite", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((interestedParty.value.address.apt) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, interestedParty.value.address.apt]
        ])
      ]),
      _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "tinylabel" }, [
          _createTextVNode("City "),
          _createElementVNode("red", null, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((interestedParty.value.address.city) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, interestedParty.value.address.city]
        ])
      ]),
      _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "tinylabel" }, [
          _createTextVNode("State "),
          _createElementVNode("red", null, "*")
        ], -1)),
        _createVNode(UsStatesBox, {
          modelValue: interestedParty.value.address.state,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((interestedParty.value.address.state) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_6, [
        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "tinylabel" }, [
          _createTextVNode("Zip "),
          _createElementVNode("red", null, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((interestedParty.value.address.zip) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, interestedParty.value.address.zip]
        ])
      ]),
      _cache[22] || (_cache[22] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
      _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
      _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
      _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          disabled: !validated.value,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (addInterestedParty()))
        }, " Notify Party ", 8, _hoisted_8)
      ])
    ], 32)
  ], 2))
}
}

})